<div class="modal-content modal-milvus" style="zoom: 0.85;">
  <ngx-spinner></ngx-spinner>
  <div class="modal-header-milvus align-items-center dark-back">
    <div class="col-6 header-col" style="margin-top: -10px; margin-left: -6px;">
      <span class="modal-title" id="modal-title-default">{{(visualizar_enviar ? 'ENVIO_IMAGEM' : 'VISUALIZAR_ARQUIVO') |
        translate}}</span>
    </div>
    <div class="col-6 header-col" style="margin-top: -10px;">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
        <i class="mdi mdi-close"></i>
      </button>
    </div>
  </div>
  <div class="modal-body preview-modal" style="text-align: center;">
    <ng-container *ngIf="fileType === 'image'">
      <img [src]="visualizar_enviar || sanitizedUrl ? sanitizedUrl : fileUrl" alt="Image Preview"
        class="full-body-preview" />
    </ng-container>

    <ng-container *ngIf="fileType === 'audio'">
      <audio controls class="full-body-preview">
        <source [src]="sanitizedUrl || fileUrl" type="audio/mpeg" />
        {{'NAVEGADOR_NAO_SUPORTA_AUDIO' | translate}}
      </audio>
    </ng-container>

    <ng-container *ngIf="fileType === 'video'">
      <video controls class="full-body-preview">
        <source [src]="sanitizedUrl || fileUrl" type="video/mp4" />
        {{'NAVEGADOR_NAO_SUPORTA_VIDEO' | translate}}
      </video>
    </ng-container>

    <ng-container *ngIf="fileType === 'pdf'">
      <iframe [src]="sanitizedUrl" class="full-body-preview"></iframe>
    </ng-container>
  </div>
  <div class="modal-footer modal-footer-milvus-+">
    <ng-container *ngIf="visualizar_enviar; else footerVisualizacao">
      <button type="button" class="btn btn-darkblue badge-pill" (click)="close(true)">
        <span [translate]="'ENVIAR'"></span>
      </button>
    </ng-container>
    <ng-template #footerVisualizacao>
      <button type="button" class="btn btn-darkblue badge-pill" (click)="abrirNovaGuia()">
        <span [translate]="'ABRIR_GUIA_EXTERNA'"></span>
      </button>
      <button type="button" class="btn btn-light badge-pill" (click)="close()">
        <span [translate]="'FECHAR'"></span>
      </button>
    </ng-template>
  </div>
</div>